import { type HTMLAttributes, type MouseEvent, useCallback } from "react";
import cx from "classnames";
import type { ClusterRunResponse } from "src/queries/compute/compute.types";
import { formatPitForDisplay } from "src/utils/time";

export type RunTimeSelectorOptionOnClickType = (
  e: MouseEvent<HTMLLIElement>,
  option: Partial<ClusterRunResponse>
) => void;

export interface RunTimeSelectorDefaultRenderOptionProps
  extends Omit<HTMLAttributes<HTMLLIElement>, "onClick"> {
  option: Partial<ClusterRunResponse>;
  onClick: RunTimeSelectorOptionOnClickType;
}

const RunTimeSelectorDefaultRenderOption = ({
  option,
  onClick,
  ...props
}: RunTimeSelectorDefaultRenderOptionProps) => {
  const onLocalClick = useCallback(
    (e: MouseEvent<HTMLLIElement>) => {
      onClick?.(e, option);
    },
    [onClick, option]
  );

  return (
    <li
      {...props}
      className={cx(props.className, "flex flex-col items-start!")}
      onClick={onLocalClick}
    >
      {formatPitForDisplay(option.run_time)}
    </li>
  );
};

export default RunTimeSelectorDefaultRenderOption;
